module.exports = __webpack_public_path__ + "9bd4ec74c266626b4b8ed7d4c40c13af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/vertex_pharmaceuticals_2023_chart.png
// module id = 1757
// module chunks = 0